/**
 * 个人用户相关接口
 */
import request from './request'

/**
 * 获取用户信息
 */
export function getUserInfo() {
  return request.post('/api/member/home/getUserInfo')
}

/**
 * 更新用户头像
 * @param {string} avatar - 头像图片地址
 */
export function changeAvatar(avatar) {
  return request.post('/api/member/home/changeAvatar', { avatar })
}

/**
 * 修改昵称
 * @param {string} nickname - 昵称
 */
export function changeNickname(nickname) {
  return request.post('/api/member/home/changeNickname', { nickname })
}

/**
 * 修改绑定手机
 * @param {object} params - { code, newMobile, password }
 */
export function changePhone(params) {
  return request.post('/api/member/home/changePhone', params)
}

/**
 * 修改登录密码
 * @param {object} params - { mobile, code, password }
 */
export function changePassword(params) {
  return request.post('/api/member/home/changePassword', params)
}

/**
 * 提交实名认证信息
 * @param {object} params - 实名认证完整参数
 */
export function submitIdInfo(params) {
  return request.post('/api/member/home/submitIdInfo', params)
}

/**
 * 获取个人首页数据
 */
export function getMemberIndexInfo() {
  return request.post('/api/member/home/getIndexInfo')
}
